<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-md-offset-1">
        <div class="card card-wizard" id="wizardCard">
          <form-wizard ref="wizard" error-color="#EB5E28" color="#1e94fd" title="Información Personal" subtitle="" finishButtonText="Siguiente" @on-loading="setLoading">

            <tab-content title="Información General" icon="ti-user" :before-change="guardaDatosPersonales">
              <datos-personales ref="DatosPersonales"></datos-personales>
            </tab-content>

            <tab-content title="Datos Curriculares" icon="ti-book" :before-change="guardaDatosCurric">
              <datos-curriculares ref="DatosCurriculares"></datos-curriculares>
            </tab-content>

            <tab-content title="Experiencia Laboral" icon="ti-briefcase" :before-change="guardaExperienciaLaboral">
              <experiencia-laboral ref="ExperienciaLaboral"></experiencia-laboral>
            </tab-content>
            <!-- v-if="this.grupo != 3" -->
            <tab-content title="Pareja y/o dependiente económico " icon="ti-user" :before-change="terminaDependientes">
              <datos-conyuge ref="DatosConyuge"></datos-conyuge>
            </tab-content>

            <tab-content title="Encargo Actual" icon="ti-briefcase" :before-change="terminaActual">
              <encargo-actual ref="EncargoActual"></encargo-actual>
            </tab-content>

            <button slot="prev" class="btn btn-default btn-fill btn-wd btn-back">Atrás</button>
            <button slot="next" class="btn btn-info btn-fill btn-wd btn-next">Siguiente</button>
            <button slot="finish" class="btn btn-info btn-fill btn-wd btn-next">Siguiente</button>
          </form-wizard>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    FormWizard,
    TabContent
  } from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import DatosPersonales from './Formularios/Personal/DatosPersonales.vue'
  import DatosCurriculares from './Formularios/Personal/DatosCurriculares.vue'
  import ExperienciaLaboral from './Formularios/Personal/ExperienciaLaboral.vue'
  import EncargoActual from './Formularios/Personal/EncargoActual.vue'
  import DatosConyuge from './Formularios/Personal/DatosConyuge.vue'
  import swal from 'sweetalert2'
  export default {
    data() {
      return {
        wizardModel: {},
        dPersonales: {},
        dCurriculares: {},
        domicilio: {},
        // grupo: null,

        loadingWizard: false,
      }
    },
    components: {
      FormWizard,
      TabContent,
      DatosPersonales,
      DatosCurriculares,
      ExperienciaLaboral,
      DatosConyuge,
      EncargoActual
    },
    created() {
      this.checkPermissions()
      this.getKey('email');
      // this.grupo = this.getKey('grupo');
    },
    watch: {
      '$route': 'checkPermissions'
    },
    mounted() {
      this.$refs.wizard.activateAll();
    },
    methods: {
      checkPermissions() {
        if (!(this.getKey('role') == 0 && this.getKey('status_dec') == 1)) {
          localStorage.clear();
          this.$router.push('/login');
          this.$router.go();

        }
      },
      setLoading: function (value) {
        this.loadingWizard = value
      },
      guardaDatosPersonales() {
        // var form2=this.$refs.DatosPersonales.valida();
        //console.log(form2);
        this.checkPermissions()
        return new Promise((resolve, reject) => {
          //this.$validator.validateAll().then(response => {
          //this.$refs.DatosPersonales.validateAll().then(response => {
          this.$refs.DatosPersonales.valida().then(response => {

            if (response) {
              this.dPersonales = this.$refs.DatosPersonales.model;
              //guarda los datos
              this.$http.put('infpersonal/' + this.$refs.DatosPersonales.ip_id, this.dPersonales).then(
                response => {
                  this.StepOk("Guardado");
                }, error => {
                  this.StepError(error);
                  console.log(error);
                }
              )

              return resolve(true) //después de enviar, deja continuar
            } else
              return resolve(false);
          })
        })

      },
      guardaDatosCurric() {
        this.checkPermissions()
        this.$refs.DatosCurriculares.validate().then(
          response => {
            if (response) {

              this.StepOk("Guardado")
            } else {
              this.StepW("Hay campos sin completar");
            }
          })
        return this.$refs.DatosCurriculares.validate()
      },
      guardaExperienciaLaboral() {
        this.checkPermissions()
        return new Promise((resolve, reject) => { //el tab wizard necesita que se regrese una promesa para dejar continuar
          this.$refs.ExperienciaLaboral.validate().then( //funcion de datos personales que valida tdo
            response => {
              if (response) {
                return resolve(true) //después de enviar, deja continuar
              } else {
                this.StepW("Hay campos sin completar");
                return reject(false) //si no todo es valido, no deja continuar
              }
            }).catch(e => {
            reject(false)
          });
        })

      },
      terminaDependientes() {
        this.checkPermissions()
        return new Promise((resolve, reject) => {
          this.$refs.DatosConyuge.validate().then(
            response => {
              if (response.every(this.isTrue)) {
                this.StepOk("Guardado");
                return resolve(true)
              } else {
                console.log(response)
                return reject(false)
              }
            }).catch(e => {
            reject(false)
          });
        })
      },
      terminaActual() {
        this.checkPermissions()
        return new Promise((resolve, reject) => {
          //el tab wizard necesita que se regrese una promesa para dejar continuar
          this.$refs.EncargoActual.validate().then(
            response => {
              if (response) {
                //si se valida correctamente el primer formilario, valida el 2do
                this.$http.put('encargoAct/' + this.$refs.EncargoActual.ip_id, this.$refs.EncargoActual.model).then(
                  response => {
                    if (this.$refs.EncargoActual.bandera == '1') {
                      this.$http.put('otroEncargo/' + this.$refs.EncargoActual.ip_id, this.$refs.EncargoActual.model2).then(
                        response => {
                          this.StepOk("Guardado");
                          /* if ( this.grupo != 3) {//si es grupo 1 o 2
                           this.$router.push('intereses')
                            return resolve(true)
                          }
                          else{
                            this.$router.push('ingresos')
                            return resolve(true)
                          } */
                          this.$router.push('intereses');


                        }, error => {
                          this.StepError(error);
                          console.log(error);
                        })
                    } else {
                      this.$http.delete('otroEncargo/' + this.$refs.EncargoActual.ip_id).then(
                        response => {
                          this.StepOk("Guardado");
                          /* if ( this.grupo != 3) {//si es grupo 1 o 2
                            this.$router.push('intereses')
                            return resolve(true)
                          }
                          else{
                            this.$router.push('ingresos')
                            return resolve(true)
                          } */
                          this.$router.push('intereses');


                        }, error => {
                          this.StepError(error);
                          console.log(error);
                        })
                    }

                  }, error => {
                    this.StepError(error);
                    console.log(error);
                  }
                )
              } else {
                this.StepW("Hay campos sin completar");
                return reject(false)
              }
            }).catch(e => {
            reject(false)
          });
        })
      },
      isTrue(currentValue) {
        return currentValue;
      }
    }

  }

</script>
<style>
  .vue-form-wizard .wizard-icon-circle.tab_shape {
    background-color: #9A9A9A !important;
    color: white;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/InfPersonal.vue